import API from "@/utils/api/index";

export async function fetchAllBrands({ limit = 100, offset = 0 } = {}) {
  const params = new URLSearchParams();
  params.append('_limit', limit);
  params.append('_offset', offset);

  const res = await API.get(`/zendit/brands?${params.toString()}`);
  return res.data?.list || [];
}

// Brand map (with offers grouped per brand)
export async function fetchBrandsMap() {
  const res = await API.get('/zendit/brands');
  if (!res.data) throw new Error('Failed to load brand map');
  return res.data; // { [brandKey]: { brandName, image, offers:[...] } }
}


export async function fetchBrandDetails(code) {
  const res = await API.get(`/zendit/brands/${code}`);
  return res.data;
}



